(() => {
  const enhanceHero = () => {
    document.querySelectorAll('.hero-slider').forEach((slider) => {
      const walletLink = slider.querySelector('a[href="https://kifl.pk/pages/mens-accessories"]');
      if (walletLink) walletLink.href = '/collections/wallets';

      slider.querySelectorAll('.arrow').forEach((control) => {
        const isPrevious = control.classList.contains('prev');
        control.classList.add('kifl-hero-control');
        control.setAttribute('role', 'button');
        control.setAttribute('tabindex', '0');
        control.setAttribute('aria-label', isPrevious ? 'Previous slide' : 'Next slide');
        control.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            control.click();
          }
        });
      });
    });
  };

  const getCroStrings = () => {
    const source = document.querySelector('[data-kifl-cro-strings]');
    return {
      sizeRequired: source?.dataset.sizeRequired || '',
      engravingRequired: source?.dataset.engravingRequired || '',
    };
  };

  const setError = (field, message, className) => {
    if (!field) return;
    field.setAttribute('aria-invalid', 'true');
    let error = field.parentElement?.querySelector(`.${className}`);
    if (!error) {
      error = document.createElement('p');
      error.className = className;
      error.setAttribute('role', 'alert');
      field.insertAdjacentElement('afterend', error);
    }
    error.textContent = message;
  };

  const clearError = (field, className) => {
    field?.removeAttribute('aria-invalid');
    field?.parentElement?.querySelector(`.${className}`)?.remove();
  };

  const engravingIsActive = () => {
    const wrapper = document.getElementById('engraving-wrapper');
    return Boolean(wrapper && window.getComputedStyle(wrapper).display !== 'none');
  };

  const syncEngraving = () => {
    const input = document.getElementById('engraving-name');
    if (!input) return;
    const active = engravingIsActive();
    input.required = active;
    if (active) {
      input.name = 'properties[Engraving Name]';
      input.setAttribute('aria-required', 'true');
    } else {
      input.removeAttribute('name');
      input.removeAttribute('aria-required');
      clearError(input, 'kifl-cro-error');
    }
  };

  const validateEngraving = () => {
    syncEngraving();
    const input = document.getElementById('engraving-name');
    if (!engravingIsActive() || input?.value.trim()) {
      clearError(input, 'kifl-cro-error');
      return true;
    }
    setError(input, getCroStrings().engravingRequired, 'kifl-cro-error');
    input?.focus();
    input?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return false;
  };

  const sizeControls = (productInfo) =>
    Array.from(productInfo.querySelectorAll('[data-option-name], select[name^="options["]')).filter((control) => {
      const name = control.dataset.optionName || control.getAttribute('name') || '';
      return name.toLowerCase().includes('size');
    });

  const setPurchaseDisabled = (productInfo, disabled) => {
    productInfo.querySelectorAll('.product-form__submit, .shopify-payment-button__button, .mw-sticky-atc, .mw-sticky-buy-now').forEach((button) => {
      if (disabled) {
        if (!button.disabled) button.dataset.kiflSizeGated = 'true';
        button.setAttribute('disabled', 'disabled');
        button.setAttribute('aria-disabled', 'true');
      } else if (
        button.dataset.kiflSizeGated === 'true' &&
        !button.textContent.toLowerCase().includes('sold out') &&
        !button.textContent.toLowerCase().includes('unavailable')
      ) {
        button.removeAttribute('disabled');
        button.removeAttribute('aria-disabled');
        delete button.dataset.kiflSizeGated;
      }
    });
  };

  const syncSizeGate = (productInfo) => {
    const suffix = productInfo.dataset.templateSuffix;
    if (suffix !== 'summer-wear' && suffix !== 'chiken-kaari') return;
    const controls = sizeControls(productInfo);
    if (!controls.length) return;
    const chosen = productInfo.dataset.kiflSizeChosen === 'true' || new URLSearchParams(window.location.search).has('variant');
    setPurchaseDisabled(productInfo, !chosen);
    const container = controls[0].closest('.product-form__input');
    let prompt = container?.querySelector('.kifl-size-prompt');
    if (!chosen && container && !prompt) {
      prompt = document.createElement('p');
      prompt.className = 'kifl-size-prompt';
      prompt.setAttribute('role', 'status');
      prompt.textContent = getCroStrings().sizeRequired;
      container.appendChild(prompt);
    } else if (chosen) {
      prompt?.remove();
    }
  };

  const initProductCro = () => {
    const productInfo = document.querySelector('product-info');
    if (!productInfo) return;

    syncEngraving();
    syncSizeGate(productInfo);

    productInfo.addEventListener('click', (event) => {
      if (event.target.closest('[data-option-name*="Size" i], label[for]')) {
        const linkedInput = event.target.closest('label[for]')
          ? document.getElementById(event.target.closest('label[for]').htmlFor)
          : event.target.closest('[data-option-name]');
        if ((linkedInput?.dataset.optionName || '').toLowerCase().includes('size')) {
          productInfo.dataset.kiflSizeChosen = 'true';
          window.setTimeout(() => syncSizeGate(productInfo), 50);
        }
      }
    });

    productInfo.addEventListener('change', (event) => {
      const optionName = event.target.dataset.optionName || event.target.getAttribute('name') || '';
      if (optionName.toLowerCase().includes('size')) productInfo.dataset.kiflSizeChosen = 'true';
      window.setTimeout(() => {
        syncEngraving();
        syncSizeGate(productInfo);
      }, 80);
    });

    document.addEventListener('click', (event) => {
      const purchaseControl = event.target.closest('.product-form__submit, .shopify-payment-button__button, .mw-sticky-atc, .mw-sticky-buy-now');
      if (!purchaseControl) return;
      if (!validateEngraving()) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);

    document.addEventListener('submit', (event) => {
      if (!event.target.matches('form[action*="/cart/add"]')) return;
      if (!validateEngraving()) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);

    document.getElementById('engraving-name')?.addEventListener('input', (event) => {
      if (event.target.value.trim()) clearError(event.target, 'kifl-cro-error');
    });

    const observer = new MutationObserver(() => {
      syncEngraving();
      syncSizeGate(productInfo);
    });
    observer.observe(productInfo, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      enhanceHero();
      initProductCro();
    }, { once: true });
  } else {
    enhanceHero();
    initProductCro();
  }
})();
